import { useDispatch, useSelector } from "react-redux";

import { closeSnackbar } from "@/store/reducers/app";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function SnackbarContainer() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const snackbar = useSelector((state) => state.app.snackbar);

  return (
    <Snackbar
      open={!!snackbar}
      message={snackbar}
      autoHideDuration={5000}
      onClose={() => dispatch(closeSnackbar())}
      anchorOrigin={{
        vertical: matches ? "top" : "bottom",
        horizontal: "center",
      }}
      action={
        <Button color="secondary" onClick={() => dispatch(closeSnackbar())} id="snackbar-close">
          Close
        </Button>
      }
    />
  );
}

export default SnackbarContainer;
